import area from "@/assets/js/area.js";
import { l, GetResourceUrl } from "@/assets/js/i18n.js";
import countryList from "@/assets/js/country-data.js";

let baseURL, title;
switch (process.env.NODE_ENV) {
    case "production":
        baseURL = "/";
        var ws = "ws";
        if (location.protocol.indexOf("https") != -1) {
            ws = "wss";
        }
        break;

    default:
        // baseURL = "http://47.99.116.223:48008/";
        // baseURL = "http://47.99.116.223:48007/"; // 测试环境
        // baseURL = "http://47.99.116.223:48017/";
        // baseURL = "https://www.chinaduancai.com";

        baseURL = "https://local.chinaduancai.com/";

        // baseURL = "http://127.0.0.1:8000/";
        // baseURL = "http://en.chinaduancai.com/"; // baseURL = "http://47.99.116.223:48004/";


        break;
}


document.title = l("中锻材-锻材交易_锻件定制_锻造加工_锻件采购_锻材现货_买锻材");

// http://47.99.116.223:48017/    demo页面
// http://47.99.116.223:48018/   local页面


// 48006  pro线上环境
// 48007  dev测试环境
// 48008  http://local.chinaduancai.com/ local开发环境 

const weight_methodList = [
    {
        id: 1,
        name: l("过磅"),
    },
    {
        id: 2,
        name: l("理计"),
    },
];
const characterList = [
    {
        id: 1,
        name: l("正品现货")
    },
    {
        id: 2,
        name: l("二级余料")
    },
];
const have_warrantyList = [
    {
        id: 1,
        name: l("是"),
    },
    {
        id: 0,
        name: l("否"),
    },
];
const have_reportList = [
    {
        id: 1,
        name: l("是"),
    },
    {
        id: 0,
        name: l("否"),
    },
];

const credit_ratingList = [
    {
        id: 0,
        name: l("冻结"),
    },
    {
        id: 1,
        name: l("受限"),
    },
    {
        id: 2,
        name: l("良好"),
    },
    {
        id: 3,
        name: l("高"),
    },
    {
        id: 4,
        name: l("极佳"),
    },
];

const forge_typeList = [
    {
        id: 1,
        name: l("自由锻")
    },
    {
        id: 2,
        name: l("模锻")
    },
    {
        id: 3,
        name: l("快锻")
    },
    {
        id: 4,
        name: l("碾环")
    }
];

export default {
    baseURL,
    title,
    characterList,
    weight_methodList,
    have_warrantyList,
    have_reportList,
    areaList: area.areaList,
    cityList: area.cityList,
    credit_ratingList,
    forge_typeList,
    countryList
};
